import { countries, Country } from 'countries-list';
import { keys } from 'lodash';

export interface CountryWithCode {
    code: string;
    country: Country;
}

const allCountryCodes = keys(countries);
const allCountries: CountryWithCode[] = allCountryCodes.map((countryCode) => {
    const country = countries[countryCode];

    return {
        code: countryCode,
        country,
    };
});

const allSortedCountries = allCountries.sort((countryA, countryB) => {
    if (countryA.country.name < countryB.country.name) {
        return -1;
    } else if (countryA.country.name > countryB.country.name) {
        return 1;
    } else {
        return 0;
    }
});

export default allSortedCountries;
